const getHomeDirectory = () => '';

export default getHomeDirectory;
